<template>
  <div class="overflow-hidden slide-type-list-section-integrations">
    <div class="slide-type-section-label">
      <aha-icon
        name="integration-instructions-rounded"
        class="icon mr-2"
        width="21"
        height="21"
        viewBox="0 0 20 20"
      >
      </aha-icon>
      <span class="text-base font-bold">Integrations</span>
    </div>
    <div class="slide-type-section-content">
      <!-- Google Slides -->
      <div
        v-aha-emit-action
        name="slideTypeListGoogleSlidesIntegration"
        class="box-type"
        @click="openIntegrationPage('google-slides')"
      >
        <div class="box-content vertical layout center-justified ml-0.25 relative pointer">
          <div class="justify-center aha-slide-type-icon">
            <div class="aha-icon-slide-wrapper">
              <aha-icon
                name="googleslide"
                :maintainColor="true"
                width="30"
                height="30"
                viewBox="0 0 28 28"
              />
              <div class="mt-0.5 text-sm text-secondary-100">
                <span>Google Slides</span>
              </div>
              <aha-icon
                name="arrow-square-out"
                class="external-link-icon absolute top-2 right-2"
                width="16"
                height="16"
              ></aha-icon>
            </div>
          </div>
        </div>
      </div>

      <!-- PowerPoint -->
      <div
        v-aha-emit-action
        name="slideTypeListPowerPointIntegration"
        class="box-type"
        @click="openIntegrationPage('powerpoint')"
      >
        <div class="box-content vertical layout center-justified ml-0.25 relative pointer">
          <div class="justify-center aha-slide-type-icon">
            <div class="aha-icon-slide-wrapper">
              <aha-icon
                name="PowerPoint"
                :maintainColor="true"
                width="30"
                height="30"
                viewBox="0 0 28 28"
              />
              <div class="mt-0.5 text-sm text-secondary-100">
                <span>PowerPoint</span>
              </div>
              <aha-icon
                name="arrow-square-out"
                class="external-link-icon absolute top-2 right-2"
                width="16"
                height="16"
              ></aha-icon>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IntegrationsSection',
  methods: {
    openIntegrationPage(type) {
      const integrationUrls = {
        'google-slides': 'https://workspace.google.com/marketplace/app/ahaslides_quiz_live_polls_word_clouds_mo/362095682738',
        powerpoint: 'https://appsource.microsoft.com/en-us/product/office/WA200004824?tab=Overview',
      }

      window.open(integrationUrls[type], '_blank')
    },
  },
}
</script>

<style lang="scss" scoped>
.slide-type-list-section-integrations {
  margin-top: 0;
}

.slide-type-section-label {
  padding: 8px 12px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  background-color: rgba(47, 128, 237, 0.15);

  .icon {
    color: #348EF6;
  }
}

.slide-type-section-content {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 10px;
  padding-top: 12px;
  padding-bottom: 24px;
}

.box-type {
  @apply text-secondary-50;
  text-align: center;
  position: relative;
  cursor: pointer;
}

.box-content {
  @apply ring-1 ring-inset ring-secondary-40;
  display: flex;
  border-radius: 4px;
  position: relative;
  overflow: hidden;
  padding: 2px 0 0;
  min-height: 72px;
  transition: 0.5s;
  transition-timing-function: cubic-bezier(0.33, 1, 0.68, 1);

  &:hover {
    @apply shadow-lg;
  }
}

.aha-slide-type-icon {
  @apply w-full text-xs leading-4 text-center flex-1 relative;
  display: flex;
}

.aha-icon-slide-wrapper {
  @apply w-full flex flex-col items-center justify-center;
  padding-top: 10px;
  padding-bottom: 10px;
  position: relative;
}

.external-link-icon {
  visibility: hidden;
  opacity: 0;
  color: #282E3E;
  transition: opacity 0.2s ease-in-out, visibility 0.2s ease-in-out;
  top: 4px;
  right: 6px;
}

.box-content:hover .external-link-icon {
  visibility: visible;
  opacity: 1;
}
</style>
